export default __webpack_public_path__ + "static/media/Samsung Galaxy Note20 Ultra.0d42e449.png";